import React, { Component } from 'react';
import { Trans } from '@lingui/macro';
import { connect } from 'react-redux';
import { DollarOutlined, PercentageOutlined, UserOutlined } from '@ant-design/icons';
import BukkuTooltip from "bukku/components/Tooltip";
import Styled from './style';
import { Type } from '../../../../redux/Transaction/helper';
import MyinvoisDocumentStatus from '../../../Columns/MyinvoisDocumentStatus';
import SyncedIcon from '../../../Icons/Sync';

class NumberCell extends Component {
    suffix = {
        cash_sales: { icon: <DollarOutlined />, text: <Trans>Cash Sales</Trans> },
        cash_purchase: { icon: <DollarOutlined />, text: <Trans>Cash Purchase</Trans> },
        expense_claim: { icon: <UserOutlined />, text: <Trans>Expense Claim</Trans> },
    };

    renderLabel = () => {
        const {
            record,
        } = this.props;

        if (record?.is_interest) {
            return (
                <div className="label">
                    <BukkuTooltip title={<Trans>Interest Invoice</Trans>}>
                        <PercentageOutlined />
                    </BukkuTooltip>
                </div>
            );
        }
        return null;
    };

    renderSuffix = () => {
        const {
            record,
        } = this.props;

        let suffixItem = null;

        if (!record)
            return null;

        switch (record.type) {
            case Type.sale_invoice:
            case Type.opening_invoice:
                if (record.payment_mode === 'cash')
                    suffixItem = this.suffix.cash_sales;
                break;
            case Type.purchase_bill:
            case Type.opening_bill:
                if (record.payment_mode === 'cash')
                    suffixItem = this.suffix.cash_purchase;
                else if (record.payment_mode === 'claim')
                    suffixItem = this.suffix.expense_claim;
                break;
            default:
                break;
        }

        if (!suffixItem)
            return null;
        return (
            <div className="label">
                <BukkuTooltip title={suffixItem.text}>{suffixItem.icon}</BukkuTooltip>
            </div>
        );
    };

    render() {
        const {
            text,
            companyCountryCode,
            record,
        } = this.props;

        return (
            <Styled>
                <div className="number">
                    <BukkuTooltip title={text}>
                        <span className="bidi-punctuation">{text || '-'}</span>
                    </BukkuTooltip>
                </div>
                {this.renderLabel()}
                {this.renderSuffix()}

                {
                    companyCountryCode === 'MY' && (record?.myinvois_document_status) ? (
                        <>
                            &nbsp;
                            <MyinvoisDocumentStatus
                                documentStatus={record.myinvois_document_status}
                                isConsolidated={record?.is_consolidated}
                                // canRefetchSubmitted
                                // refetchSubmittedProps={{
                                //     mode: 'list',
                                //     transactionId: record.id,
                                //     transactionType: record.type,
                                //     myInvoisId: null, // Not applicable for transactions
                                // }}
                            />
                        </>
                    ) : null
                }
                {
                    companyCountryCode === 'MY' && record?.is_synced ? (
                        <>
                            &nbsp;
                            <SyncedIcon />
                            &nbsp;
                            <MyinvoisDocumentStatus
                                documentStatus="VALID"
                                isConsolidated={false}
                            />
                        </>
                    ) : null
                }
            </Styled>
        );
    }
}
export default connect(state => ({
    companyCountryCode: state.Auth.companyCountryCode,
}), {
    //
})(NumberCell);
